module.exports = "/images/economy-and-finance.png?82c29ae3436d02f365dfcd772f25e6af";